export default __webpack_public_path__ + "static/media/22.7f2af895.png";